import BaseService from '../BaseService'
import axios from "axios";

class SubscriptionService extends BaseService {
    constructor() {
        super('/subscription');
    }

    pricing() {
        return axios.get(`${this.resource}/pricing`)
    }

    getPlanDetail({ query = '' }) {
        const q = query.length > 0 ? `?${query}` : ''

        return axios.get(`${this.resource}/get-plan-detail${q}`)
    }

    setFreePlan() {
        return axios.post(`${this.resource}/set-free-plan?notificationOff`)
    }

    getSubscriptionDetails() {
        return axios.get(`${this.resource}/details`)
    }

    getAvailablePlans() {
        return axios.get(`${this.resource}/available-plans`)
    }
}

export default new SubscriptionService()
